
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  getCurrentInstance,
} from "vue";
import { addResourceType, fromType } from "./addResourceType";
import { Router, useRoute, useRouter } from "vue-router";
import ImageForm from "@/components/imageForm/ImageForm.vue";
import VideoForm from "@/components/videoForm/videoForm.vue";
import {
  getVarietyList,
  getSourceDetail,
  editSourceDetail,
} from "../../../../api/farmer";
import {
  dateFormat,
  directUploadFile,
  itemType,
  previewImage,
} from "@/utils/util";
import TencentMapSelect from "@/components/tencentMapSelect/TencentMapSelect.vue";
import { areaList, getFileToken } from "../../../../api/user";
import PreviewVideo from "@/components/previewVideo/previewVideo.vue";
import { Toast } from "vant";

function states() {
  return {
    showVariety: false,
    varietyOptions: [],
    selectedVariety: "",
    varietyData: "",
    showDateDialog: false,
    selectedMD: "",
    message: "",
    showMapSelect: false,
    showLocation: false,
    areaAllList: [], //地区列表
    fieldNames: {
      text: "areaName",
      value: "areaId",
      children: "values",
    },
    variety: {},
    imgList: [],
    videoList: [],
    sourceId: "",
    showVideos: false,
    videoUrl: "",
  };
}
function fromState() {
  return {
    address: "",
    detail: "",
    area: "",
    selectedDate: "",
    period: "",
    yieldNumber: "",
    provinceId: 0,
    provinceStrName: "",
    cityId: 0,
    cityStrName: "",
    areaId: "",
    areaStrName: "",
    remark: "",
    type: "",
  };
}

export default defineComponent({
  setup(props, ctx) {
    const route = useRoute();
    const router = useRouter();
    let state = reactive<addResourceType>(states());
    let fromStates = reactive<fromType>(fromState());
    const getCurrt = getCurrentInstance();
    const {
      onConfirmVariety,
      onConfirmLocation,
      delHeadIcon,
      afterRead,
      afterReadVideo,
      delHeadVideo,
      onClickImgPoster,
      onClickVideoPoster,
    } = useEvent(state, fromStates);
    const { getVarietyDataList, confirmDate, getArea, submit, getFarmerInfo } =
      useNetwork(state, route, getCurrt, fromStates, router);
    onMounted(() => {
      state = Object.assign(state, states());
      fromStates = Object.assign(fromStates, fromState());
      getVarietyDataList();
      getArea();
      if (route.query.id) {
        state.sourceId = route.query.id as string;
        getFarmerInfo();
      }
    });
    return {
      ...toRefs(state),
      ...toRefs(fromStates),
      onConfirmVariety,
      delHeadIcon,
      afterRead,
      confirmDate,
      onConfirmLocation,
      afterReadVideo,
      delHeadVideo,
      submit,
      getFarmerInfo,
      onClickVideoPoster,
      onClickImgPoster,
    };
  },
  components: {
    ImageForm,
    VideoForm,
    TencentMapSelect,
    PreviewVideo,
  },
});

/**
 * 其他工具函数hooks
 */
const useOtherFun = (state: addResourceType) => {
  const filterValues = function (list: Array<any>): Array<any> {
    list.forEach((item) => {
      if (item.values.length == 0) {
        delete item.values;
      } else {
        filterValues(item.values);
      }
    });
    return list;
  };
  return {
    filterValues,
  };
};

/**
 * 接口数据hooks
 */
const useNetwork = (
  state: addResourceType,
  route: any,
  getCurrt: any,
  fromState: fromType,
  router: Router
) => {
  const getFarmerInfo = async () => {
    const result: any = await getSourceDetail({ id: route.query.id });
    const dataObj: any = result.data.data;
    fromState.address =
      dataObj.provinceStrName +
      "/" +
      dataObj.cityStrName +
      "/" +
      dataObj.areaStrName;

    fromState.provinceId = dataObj.provinceId;
    fromState.cityId = dataObj.cityId;
    fromState.areaId = dataObj.areaId;
    fromState.detail = dataObj.addressInfo;
    fromState.cityStrName = dataObj.cityStrName;
    fromState.provinceStrName = dataObj.provinceStrName;
    fromState.areaStrName = dataObj.areaStrName;
    fromState.area = dataObj.plantArea;
    fromState.period = dataObj.supplyCycle;
    fromState.yieldNumber = dataObj.yield;
    fromState.remark = dataObj.remark;
    fromState.selectedDate = dataObj.launchDate;
    fromState.type = dataObj.type;
    state.imgList = dataObj.images.map((item: itemType) => {
      // 将状态设置为已完成
      item.progress = 100;
      item.status = 1;
      item.poster = item.url;
      return item;
    });
    state.videoList = dataObj.videos.map((item: itemType) => {
      item.progress = 100;
      item.status = 1;
      item.poster = item.coverImg;
      return item;
    });
    getCurrt.ctx.$forceUpdate();
  };
  const getVarietyDataList = async () => {
    const result: any = await getVarietyList();
    if (result.data.code == 0) {
      state.varietyOptions = result.data.data;
    }
  };

  const confirmDate = (e: any) => {
    fromState.selectedDate = dateFormat(e).MM + "-" + dateFormat(e).DD;
    state.showDateDialog = false;
  };
  const getArea = async () => {
    const result: any = await areaList();
    state.areaAllList = result.data.data;
  };

  const submit = async (value: any) => {
    let obj: any = {
      areaId: fromState.areaId,
      imgIds: state.imgList.map((item: any) => item.id).join(","),
      videoIds: state.videoList.map((item: any) => item.id).join(","),
      addressInfo: fromState.detail,
      remark: fromState.remark,
      launchDate: fromState.selectedDate,
      supplyCycle: fromState.period,
      provinceId: fromState.provinceId,
      cityId: fromState.cityId,
      yield: fromState.yieldNumber,
      plantArea: +fromState.area,
      provinceStrName: fromState.provinceStrName,
      cityStrName: fromState.cityStrName,
      areaStrName: fromState.areaStrName,
      type: fromState.type,
    };
    if (state.sourceId) {
      obj.id = state.sourceId;
    }
    console.log(obj, "objjjj");
    const result: any = await editSourceDetail(obj);
    if (result.data.code == 0) {
      Toast({ message: result.data.msg });
      router.go(-1);
    }
  };

  return {
    getVarietyDataList,
    confirmDate,
    getArea,
    submit,
    getFarmerInfo,
  };
};

/**
 * 事件类hooks
 */
const useEvent = (state: addResourceType, fromStates: fromType) => {
  const onConfirmVariety = (e: any) => {
    if (e.selectedOptions.length == 3) {
      state.varietyData = e.selectedOptions[e.selectedOptions.length - 1].name;
      fromStates.type = e.selectedOptions[e.selectedOptions.length - 1].id;
      state.showVariety = false;
    }
  };

  const onClickImgPoster = (item: any) => {
    previewImage(state.imgList, item.index);
  };

  // 删除图片
  const delHeadIcon = (item: any) => {
    state.imgList.splice(item.index, 1);
  };
  // 删除视频
  const delHeadVideo = (item: any) => {
    state.videoList.splice(item, 1);
  };
  const onClickVideoPoster = (item: any) => {
    state.videoUrl = item.url;
    state.showVideos = true;
  };
  // 选择地区
  const onConfirmLocation = (value: any) => {
    state.showLocation = false;
    let str = "";
    value.selectedOptions.forEach((option: any, index: number) => {
      if (index == 0) {
        fromStates.provinceId = option.areaId;
        fromStates.provinceStrName = option.areaName;
      } else if (index == 1) {
        fromStates.cityId = option.areaId;
        fromStates.cityStrName = option.areaName;
      } else {
        fromStates.areaId = option.areaId;
        fromStates.areaStrName = option.areaName;
      }
      console.log(fromStates, "statesssss");
      str += "/" + option.areaName;
    });
    fromStates.address = str.substr(1);
  };
  //上传视频
  const afterReadVideo = async (e: any) => {
    if (Array.isArray(e)) {
      e.forEach(async (item) => {
        const result: any = await getFileToken({
          bucket: "xfarmer",
          fileType: 1,
          type: 2,
          token: localStorage.getItem("token"),
        });
        if (result.data.code == 0) {
          directUploadFile(item, result.data, { userType: "2", fileType: "1" });
        }
      });
    } else {
      const result: any = await getFileToken({
        bucket: "xfarmer",
        fileType: 1,
        type: 2,
        token: localStorage.getItem("token"),
      });
      if (result.data.code == 0) {
        directUploadFile(e, result.data, { userType: "2", fileType: "1" });
        console.log(state.videoList, "villll");
      }
    }
  };

  //上传图片前
  const afterRead = async (e: any) => {
    if (Array.isArray(e)) {
      e.forEach(async (item) => {
        const result: any = await getFileToken({
          bucket: "xfarmer",
          fileType: 0,
          type: 2,
          token: localStorage.getItem("token"),
        });
        if (result.data.code == 0) {
          // 执行该函数后，获取数据请直接从双向绑定的数组中取值.
          directUploadFile(item, result.data);
        }
      });
    } else {
      const result: any = await getFileToken({
        bucket: "xfarmer",
        fileType: 0,
        type: 2,
        token: localStorage.getItem("token"),
      });
      if (result.data.code == 0) {
        directUploadFile(e, result.data);
      }
    }
  };
  return {
    delHeadIcon,
    afterRead,
    onConfirmVariety,
    onConfirmLocation,
    afterReadVideo,
    onClickImgPoster,
    onClickVideoPoster,
    delHeadVideo,
  };
};
